module.exports = __webpack_public_path__ + "static/media/weedmaps_bw.640aa102.png";